/**
 * Bus de eventos mínimo para invalidar datos del shell persistente.
 *
 * `DashboardLayout` carga la lista de empresas y los ejercicios del sidebar una
 * sola vez (es persistente, no se desmonta al navegar). Cuando una página crea o
 * borra una empresa/ejercicio o importa un fichero, emite este evento y el layout
 * vuelve a cargar — así el usuario no tiene que refrescar la página a mano.
 *
 * Se usa `CustomEvent` sobre `window` (mismo patrón que el tour: `startTour`),
 * para no acoplar páginas y layout ni introducir estado global todavía.
 */
export const DATA_CHANGED_EVENT = "finreport:data-changed";

/**
 * @param {("empresas"|"ejercicios")} [scope] qué cambió. Si se omite, refresca todo.
 */
export function notifyDataChanged(scope) {
  window.dispatchEvent(new CustomEvent(DATA_CHANGED_EVENT, { detail: { scope } }));
}

export function onDataChanged(handler) {
  window.addEventListener(DATA_CHANGED_EVENT, handler);
  return () => window.removeEventListener(DATA_CHANGED_EVENT, handler);
}
